import { css } from "@emotion/css"

type Props = {
  term: string
  children: string
}

const MyPageDefinition = ({ term, children }: Props) => {
  return (
    <div className={styles.container}>
      <dt className={styles.term}>{term}</dt>
      <dd className={styles.description}>{children}</dd>
    </div>
  )
}

export default MyPageDefinition

const styles = {
  container: css`
    display: flex;
    column-gap: 2px;
    min-height: 26px;
    font-size: 13px;
  `,
  term: css`
    width: 220px;
    padding: 4px 10px;
    font-weight: bold;
    line-height: 18px;
    color: #fff;
    background-color: #90c9ae;
  `,
  description: css`
    width: 518px;
    padding: 4px 10px;
    line-height: 18px;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    background-color: #f2f2f2;
  `,
}
